var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationFilterLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73386 2.77346C4.60321 1.9215 5.77366 1.44704 6.99086 1.45318C8.20806 1.45933 9.37366 1.94559 10.2344 2.80629C11.0951 3.66699 11.5813 4.83259 11.5875 6.04979C11.5936 7.26699 11.1192 8.43744 10.2672 9.30679L7.82536 11.7486C7.60658 11.9673 7.30988 12.0902 7.00053 12.0902C6.69117 12.0902 6.39448 11.9673 6.17569 11.7486L3.73386 9.30679C2.86754 8.44039 2.38086 7.26535 2.38086 6.04013C2.38086 4.81491 2.86754 3.63986 3.73386 2.77346Z",
    strokeWidth: 1.16667,
    strokeLinejoin: "round",
    stroke: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 6.04687C8.75 7.01337 7.9665 7.79687 7 7.79687C6.0335 7.79687 5.25 7.01337 5.25 6.04687C5.25 5.08038 6.0335 4.29688 7 4.29688C7.9665 4.29688 8.75 5.08038 8.75 6.04687Z",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFilterLight);
export default __webpack_public_path__ + "static/media/location-filter-light.9463f62d479085ac9381ce6835930a1e.svg";
export { ForwardRef as ReactComponent };